<template>
  <div class="sn-bs-layout">
    <div class="sn-bs-layout__header">
      <bs-header :title="farmName"></bs-header>
    </div>
    <main class="sn-bs-layout__main">
      <bs-scrollbar>
        <div class="sn-bs-layout__main-scroll-inner">
          <div class="sn-bs-layout__body">
            <slot></slot>
          </div>
          <div class="sn-bs-layout__section sn-bs-layout__section--left">
            <slot name="layout-left"></slot>
          </div>
          <div class="sn-bs-layout__section sn-bs-layout__section--right">
            <slot name="layout-right"></slot>
          </div>
          <div class="sn-bs-layout__section sn-bs-layout__section--bottom">
            <slot name="layout-bottom"></slot>
          </div>
        </div>
      </bs-scrollbar>
    </main>
  </div>
</template>

<script>
import BsScrollbar from "@/components/bs/BsScrollbar";
import BsHeader from "@/components/bs/BsHeader";
import { mapGetters } from "vuex";

export default {
  name: "BsLayout",
  computed: {
    ...mapGetters("farmInfo", ["farmName"]),
  },
  components: {
    BsHeader,
    BsScrollbar,
  },
};
</script>

<style scoped lang="scss">
@include bs(layout) {
  position: relative;
  background-color: rgba(13, 56, 46, 0.5);
  @include utils-full-box();
  &::after {
    content: "";
    box-shadow: 0 0 60px 80px rgba(0, 0, 0, 1) inset;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
    @include utils-full-box();
  }
  @include e(header) {
    height: 95px;
  }
  @include e(main) {
    position: relative;
    height: calc(100% - 95px);
  }
  @include e(main-scroll-inner) {
    position: relative;
    @include utils-clearfix();
  }
  @include e(body) {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: calc(100vh - 95px);
    pointer-events: none;
    //@include utils-full-box();
  }
  @include e(section) {
    position: relative;
    z-index: 2;
    @include m(left right) {
      width: 370px;
    }
    @include m(left) {
      float: left;
      margin-left: 16px;
    }
    @include m(right) {
      float: right;
      margin-right: 16px;
    }
    @include m(bottom) {
      position: absolute;
      left: calc(370px + 16px);
      bottom: 0;
      width: calc(100% - (370px + 28px) * 2);
      display: flex;
      justify-content: center;
    }
  }
}
</style>
